@if (mandatory() && mandatory().length) {
  <div class="mt-8">
    <h2>{{ 'common.order.accessoriesMandatory' | actrans }}</h2>
    @for (a of mandatory(); track a.id) {
      <btlib-order-accessory-item [accessory]="a"></btlib-order-accessory-item>
    }
  </div>
}

@if (optional() && optional().length) {
  <div class="mt-8">
    <h2>{{ 'common.order.accessoriesOptional' | actrans }}</h2>
    @for (a of optional(); track a.id) {
      <btlib-order-accessory-item [accessory]="a"></btlib-order-accessory-item>
    }
  </div>
}
